<template>
  <dl class="row">
    <dt class="col-7 text-right">Rank</dt>
    <dd class="col-5">{{ profile.rank }} / {{ profile.rankTotal }}</dd>

    <dt class="col-7 text-right">Percentile</dt>
    <dd class="col-5">{{ ordinal (Math.floor (profile.percentile)) }}</dd>

    <dt class="col-7 text-right">Rating</dt>
    <dd class="col-5">{{ Math.ceil (profile.rating) }}</dd>

    <dt class="col-7 text-right" v-tooltip="'Wins / Losses / Left / Played'">W / LS / LV / P</dt>
    <dd class="col-5">
      <span class="green">{{ profile.wins }}</span> /
      <span class="red">{{ profile.losses }}</span> /
      <span class="red">{{ profile.leaves || 0 }}</span> /
      {{ profile.played }}
    </dd>

    <dt class="col-7 text-right">Win Rate</dt>
    <dd class="col-5">{{ profile.winRate }}%</dd>

    <dt class="col-7 text-right">Current Winstreak</dt>
    <dd class="col-5">{{ profile.winstreak }}</dd>

    <dt class="col-7 text-right">Longest Winstreak</dt>
    <dd class="col-5">{{ profile.bestWinstreak }}</dd>

    <dt class="col-7 text-right">Average APM</dt>
    <dd class="col-5">{{ profile.avgApm }}</dd>

    <dt class="col-7 text-right">Average Stay</dt>
    <dd class="col-5">{{ profile.avgStay }}%</dd>

    <dt class="col-7 text-right">Last Played</dt>
    <dd class="col-5">{{ timeago (profile.lastPlayed) }}</dd>
  </dl>
</template>

<script>
  import Profile from '@/legacy/lib//model/Profile';
  import { ordinal, timeago } from '@/legacy/lib//util';

  export default {
    props: {
      profile: {
        type: Profile
      }
    },

    methods: {
      ordinal,
      timeago
    }
  };
</script>